import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DiscountService } from 'src/app/services/discount.service';

@Component({
  standalone: false,
  selector: 'app-discounts-detail',
  templateUrl: './discounts-detail.component.html',
})
export class DiscountsDetailComponent implements OnInit {
  id = '';
  isEditMode = false;
  validationTriggered = false;
  item: any = null;
  form: any = {};

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private discountService: DiscountService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id') ?? '';
    this.load();
  }

  load(): void {
    this.discountService.get(this.id).subscribe({
      next: (result) => {
        this.item = result?.data ?? null;
        this.resetForm();
        this.isEditMode = false;
        this.validationTriggered = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.toaster.error('Discount not found.');
        this.router.navigate(['/ecomm/discounts']);
      },
    });
  }

  resetForm(): void {
    this.form = {
      name: this.item.name,
      discount_type: this.item.discount_type,
      discount_value: this.item.discount_value,
      status: this.item.status,
    };
  }

  startEdit(): void {
    this.resetForm();
    this.isEditMode = true;
    this.validationTriggered = false;
  }

  cancelEdit(): void {
    this.resetForm();
    this.isEditMode = false;
    this.validationTriggered = false;
  }

  save(): void {
    this.validationTriggered = true;
    if (!this.form.name || this.form.discount_value === '' || this.form.discount_value === null) {
      this.toaster.error('Please fill in all required fields.');
      return;
    }

    const payload = {
      name: this.form.name,
      discount_type: Number(this.form.discount_type),
      discount_value: Number(this.form.discount_value),
      status: Number(this.form.status),
    };

    this.discountService.update(this.id, payload).subscribe({
      next: (result) => {
        this.item = result.data;
        this.isEditMode = false;
        this.validationTriggered = false;
        this.toaster.success('Discount updated.');
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.toaster.error(error?.error?.message || 'Failed to update discount.');
      },
    });
  }

  discountTypeLabel(type: number): string {
    return type === 1 ? 'Amount' : type === 2 ? 'Percentage' : String(type ?? '-');
  }

  statusLabel(status: number): string {
    return status === 1 ? 'Active' : status === 2 ? 'Inactive' : String(status ?? '-');
  }
}
